import { StandardEvents } from '@shopify/events';
// Re-render only this cart section after a cart update so exclusions stay current.
class EmivaCartRecommendations extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    document.addEventListener(StandardEvents.cartLinesUpdate, () => this.refresh(), { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); this.request?.abort(); }
  async refresh() {
    this.request?.abort();
    const request = this.request = new AbortController();
    try {
      const url = new URL(location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = html.querySelector('emiva-cart-recommendations');
      if (replacement && this.isConnected && !request.signal.aborted) this.replaceWith(replacement);
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('Cart recommendations could not be refreshed.');
    }
  }
}
if (!customElements.get('emiva-cart-recommendations')) customElements.define('emiva-cart-recommendations', EmivaCartRecommendations);
